import mock from '@/@fake-db/mock'
/* eslint-disable global-require */
const data = {
  faqData: {
    // payment
    payment: {
      icon: 'SettingsIcon',
      title: 'message.titlegettings',
      qandA: [
        {
          question: 'message.ans_how_title',
          ans: 'message.ans_how',
        },
        {
          question: 'message.ans_save_title',
          ans: 'message.ans_save',
        },
        {
          question: 'message.ans_saved_quotes_title',
          ans: 'message.ans_saved_quotes',
        },
        {
          question: 'message.ans_saved_qtab_title',
          ans: 'message.ans_saved_qtab',
        },
      ],
    },
    // payments
    payments: {
      icon: 'CreditCardIcon',
      title: 'message.paymentsandbilling',
      qandA: [
        {
          question: 'message.ans_pay_title',
          ans:'message.ans_pay_client',
          ans_pay_partner:'message.ans_pay_partner',
        },
        {
          question: 'message.ans_pclient_title',
          ans: 'message.ans_msg_one',
        },
        {
          question: 'message.ans_cl_rec_title',
          ans: 'message.ans_cl_rec',
        },
      ],
    },
    // policies
    policies: {
      icon: 'FileTextIcon',
      title: 'message.policiesanddocs',
      qandA: [
        {
          question: 'message.ans_down_title',
          ans: 'message.ans_down',
        },
        {
          question: 'message.ans_tr_ins_title',
          ans: 'message.ans_tr_ins',
        },
        {
          question: 'message.ans_see_dets_title',
          ans: 'message.ans_see_dets',
        }
      ],
    },
    // affiliates
    affiliates: {
      icon: 'UsersIcon',
      title: 'message.partnersandaffic',
      qandA: [
        {
          question: 'message.ans_promote_title',
          ans: 'message.ans_promote',
        },
      ],
    },
    // support_complains
    supportComplains: {
      icon: 'LifeBuoyIcon',
      title: 'message.supportcomplandemr',
      qandA: [
        {
          question: 'message.ans_cntc_title',
          ans: 'message.ans_cntc',
        },
        {
          question: 'message.ans_cmpl_title',
          ans: 'message.ans_cmpl_one',
          ans_cmpl_two:'message.ans_cmpl_two',
        },
        {
          question: 'message.ans_md_emrg_title',
          ans: 'message.ans_md_emrg',
        },
      ],
    },
  },
}

mock.onGet('/faq/data').reply(config => {
  const { q = '' } = config.params
  const queryLowered = q.toLowerCase()

  const filteredData = {}

  Object.entries(data.faqData).forEach(entry => {
    const [categoryName, categoryObj] = entry
    // eslint-disable-next-line arrow-body-style
    const filteredQAndAOfCategory = categoryObj.qandA.filter(qAndAObj => {
      return qAndAObj.question.toLowerCase().includes(queryLowered)
    })
    if (filteredQAndAOfCategory.length) {
      filteredData[categoryName] = { ...categoryObj, qandA: filteredQAndAOfCategory }
    }
  })

  return [200, filteredData]
})
